import { render, staticRenderFns } from "./ManagerAdditionalData.vue?vue&type=template&id=4133ccd0"
import script from "./ManagerAdditionalData.vue?vue&type=script&lang=ts"
export * from "./ManagerAdditionalData.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4133ccd0')) {
      api.createRecord('4133ccd0', component.options)
    } else {
      api.reload('4133ccd0', component.options)
    }
    module.hot.accept("./ManagerAdditionalData.vue?vue&type=template&id=4133ccd0", function () {
      api.rerender('4133ccd0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/profile/ManagerAdditionalData.vue"
export default component.exports